<template>
    <a
        :href="redirectUrl"
        class="agent-item-container"
        :target="detailUrlTarget"
        rel="noopener noreferrer"
    >
        <img-box
            :src="agentTargetImage3By4 || ''"
            dir="width"
            :alt="agent.fullName"
            errorImg="https://cdn.chime.me/image/fs/sitebuild/202457/7/original_fbb918b4-831d-43d3-8d96-68f8986a8e79.png"
            class="agent-main"
        >
            <div class="agent-info">
                <p class="info-name">{{ agent.fullName }}</p>
                <p class="info-pl">
                    <span v-if="agent.position" class="position"
                    >{{ agent.position
                    }}{{ agent.license ? ' / ' : '' }}</span
                    >
                    <span v-if="agent.license" class="license"
                    >{{ licenseName }}{{ agent.license }}</span
                    >
                </p>
            </div>
        </img-box>
    </a>
</template>
<script>
import agentInfoMixin from "../agent-info";
export default {
    props: {
        agent: {
            type: Object,
            default: () => ({})
        },
        detailUrlTarget: {
            type: String,
            default: '_self'
        },
        licenseName: {
            type: String,
            default: ''
        }
    },
    mixins: [agentInfoMixin],
};
</script>
